import { motion } from "framer-motion";

/**
 * Animated wordmark — "Maro" types in from the left in Cedarwood,
 * "canada" types in from the right in Atlas Snow. They meet at the seam.
 * Used once, on initial load only.
 *
 * Props:
 *  - size: tailwind text-size className
 *  - className: extra classes
 *  - cedar: cedar color (default Cedarwood)
 *  - snow: atlas snow color (default Atlas Snow)
 *  - duration: per-letter motion duration in seconds
 *  - once: only animate once
 */
const Maro = ["M", "a", "r", "o"];
const canada = ["c", "a", "n", "a", "d", "a"];

const AnimatedWordmark = ({
  className = "",
  cedar = "#6B4F3A",
  snow = "#F5F2EE",
  ease = [0.16, 1, 0.3, 1],
  stagger = 0.08,
  duration = 0.55,
}) => {
  const total = canada.length;
  return (
    <span
      data-testid="animated-wordmark"
      dir="ltr"
      className={`font-display inline-flex items-baseline whitespace-nowrap ${className}`}
    >
      {/* Maro (from left, cedar) */}
      <span className="inline-flex">
        {Maro.map((ch, i) => (
          <motion.span
            key={`m-${i}`}
            initial={{ opacity: 0, x: -32, filter: "blur(6px)" }}
            animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
            transition={{
              delay: i * stagger,
              duration,
              ease,
            }}
            className="inline-block"
            style={{ color: cedar }}
          >
            {ch}
          </motion.span>
        ))}
      </span>

      {/* canada (from right, snow) */}
      <span className="inline-flex italic">
        {canada.map((ch, i) => (
          <motion.span
            key={`c-${i}`}
            initial={{ opacity: 0, x: 32, filter: "blur(6px)" }}
            animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
            transition={{
              delay: (total - 1 - i) * stagger,
              duration,
              ease,
            }}
            className="inline-block"
            style={{ color: snow }}
          >
            {ch}
          </motion.span>
        ))}
      </span>
    </span>
  );
};

export default AnimatedWordmark;
